import { _ } from "libs";
import React, { FC, memo } from "react";
import { ChampionshipChallenge } from "../../types";
import ChallengeItemSmall from "../items/challenge/small";
import ChallengeItemMedium from "../items/challenge/medium";

type ChallengesProps = {
	challenges: Array<ChampionshipChallenge>;
	showIncomplete?: boolean;
	template?: ChallengeTemplate;
	activeOrExpiredTrial?: boolean;
	onChallengeSelected?: (challengeId: string, title: string) => void;
};

type ChallengeProps = {
	challenge: ChampionshipChallenge;
	template: ChallengeTemplate;
	activeOrExpiredTrial?: boolean;
	onChallengeSelected?: (challengeId: string, title: string) => void
};

export enum ChallengeTemplate {
	MEDIUM = "medium",
	BASIC = "basic",
}

const getTemplate = ({ challenge, template = ChallengeTemplate.MEDIUM, activeOrExpiredTrial, onChallengeSelected }: ChallengeProps) => {
	switch (template) {
		case ChallengeTemplate.BASIC:
			return (
				<ChallengeItemSmall
					title={challenge.label}
					description={challenge.description}
					type={challenge.type}
					progress={challenge?.values?.currentValue}
					goal={challenge?.values?.maxValue}
					complete={challenge.complete}
					reward={challenge?.reward}
				/>
			);
		default:
			return (
				<ChallengeItemMedium
					id={challenge.id}
					title={challenge.label}
					description={challenge.description}
					type={challenge.type}
					progress={challenge?.values?.currentValue}
					goal={challenge?.values?.maxValue}
					complete={challenge.complete}
					reward={challenge?.reward}
					locked={activeOrExpiredTrial && challenge?.trialEligible === false}
					rankable={challenge?.rankable}
					rank={challenge?.rank}
					onChallengeSelected={onChallengeSelected}
				/>
			);
	}
};

const Challenge: FC<ChallengeProps> = ({
	challenge,
	template = ChallengeTemplate.MEDIUM,
	activeOrExpiredTrial,
	onChallengeSelected
}: ChallengeProps) => {
	return <div className="cell">{getTemplate({ challenge, template, activeOrExpiredTrial, onChallengeSelected })}</div>;
};

export const ChallengesList: FC<ChallengesProps> = ({
	challenges,
	showIncomplete,
	template,
	activeOrExpiredTrial,
    onChallengeSelected,
}: ChallengesProps) => {
	if (!challenges || !Array.isArray(challenges) || challenges?.length === 0) {
		return null;
	}
	return (
		<div className="table">
			{challenges
				.filter((challenge) => {
					if (false === showIncomplete) {
						return challenge.complete;
					}
					return true;
				})
				.map((challenge, index) => {
					return (
						<Challenge
							challenge={challenge}
							template={template}
							key={[challenge.id, index].join("_")}
							activeOrExpiredTrial={activeOrExpiredTrial}
							onChallengeSelected={onChallengeSelected}
						/>
					);
				})}
		</div>
	);
};

const Challenges: FC<ChallengesProps> = ({
	challenges,
	showIncomplete,
	template,
	activeOrExpiredTrial,
    onChallengeSelected,
}: ChallengesProps) => {
	if (!challenges || !Array.isArray(challenges) || challenges?.length === 0) {
		return null;
	}
	return (
		<div className="nBlock championship challenges">
			<h5 className="heading">{_("championship.challenges.heading")}</h5>
			<ChallengesList
				challenges={challenges}
				showIncomplete={showIncomplete}
				template={template}
				activeOrExpiredTrial={activeOrExpiredTrial}
				onChallengeSelected={onChallengeSelected}
			/>
		</div>
	);
};

export default memo(Challenges);
